import { baseApi } from '../app/baseApi';
import { User } from '../../../shared/src/types/User';

export const usersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserById: builder.query<User, string>({
      query: (id) => `/user/${id}`,
    }),
    updateUser: builder.mutation<void, { name: string; email: string; phone: string; address?: string; notifications: boolean; }>({
      query: (user) => ({
        url: 'user/update-user',
        method: 'PUT',
        body: user,
      }),
    }),
  }),
});

export const { useGetUserByIdQuery, useUpdateUserMutation } = usersApi;